import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .service('platformSettingsService', platformSettingsService);

    function platformSettingsService() {
        var PARTIALS_DIR = 'app/platform-settings/';
        var pages = {
            general: PARTIALS_DIR + 'view.html',
            'secondary-trading': PARTIALS_DIR + 'secondary-trading.html',
            conditions: PARTIALS_DIR + 'secondary-trading.html',
            'network-points': PARTIALS_DIR + 'network-points.html',
            dashboard: PARTIALS_DIR + 'dashboard.html',
            'new-trader-list': PARTIALS_DIR + 'new-trader-list.html'
        };
        var startPage = pages.general;
        var DIRECTION = { EXIT: 'EXIT', ENTRY: 'ENTRY' };
        var NEW_FAVORITE_NETWORK_POINT_PAGE =
            PARTIALS_DIR + 'new-favorite-network-point.html';
        var NEW_QUICK_FILTER_PAGE = PARTIALS_DIR + 'new-quick-filter.html';
        var NEW_TRADING_CONDITION = PARTIALS_DIR + 'new-trading-condition.html';
        var QUICK_FILTER_PAGE = PARTIALS_DIR + 'quick-filters.html';
        var BROADCAST = {
            CANCEL_NEW_FAVORITE_NETWORK_POINT: 'cancelNewFavoriteNetworkPoint',
            CANCEL_NEW_QUICK_FILTER: 'cancelNewQuickFilter',
            NEW_FAVORITE_NETWORK_POINT: 'newFavoriteNetworkPoint',
            NEW_QUICK_FILTER: 'newQuickFilter',
            EDIT_QUICK_FILTER: 'editQuickFilter',
            CANCEL_EDIT_QUICK_FILTER: 'cancelEditQuickFilter',
            ADDED_CONDITION:
                'platform-settings_trading-conditions_successfullyAddedCondition'
        };
        var GENERAL_SETTINGS: any = {
            FAVORITE_NETWORK_POINTS: [
                {
                    ENUM: 'USER',
                    LABEL: 'User specific'
                },
                {
                    ENUM: 'SHIPPER',
                    LABEL: 'Company wide'
                }
            ],
            RECENT_ACTIVITIES: [
                {
                    ENUM: 'USER',
                    LABEL: 'User specific'
                },
                {
                    ENUM: 'SHIPPER',
                    LABEL: 'Company wide'
                }
            ],
            AMOUNT: [
                {
                    ENUM: 'KILO',
                    LABEL: 'kWh/h'
                },
                {
                    ENUM: 'MEGA',
                    LABEL: 'MWh/h'
                }
            ],
            COST: [
                {
                    ENUM: 'UNIT',
                    LABEL: 'unit/[flow unit]'
                },
                {
                    ENUM: 'SUBUNIT',
                    LABEL: 'subunit/[flow unit]'
                }
            ]
        };
        var ALL_WIDGETS = [
            'NOTIFICATIONS',
            'AUCTIONS',
            'NETWORK_POINTS',
            'PROPOSALS',
            'ACTIVITIES'
        ];

        return {
            pages: pages,
            startPage: startPage,
            DIRECTION: DIRECTION,
            BROADCAST: BROADCAST,
            NEW_FAVORITE_NETWORK_POINT_PAGE: NEW_FAVORITE_NETWORK_POINT_PAGE,
            NEW_QUICK_FILTER_PAGE: NEW_QUICK_FILTER_PAGE,
            NEW_TRADING_CONDITION: NEW_TRADING_CONDITION,
            QUICK_FILTER_PAGE: QUICK_FILTER_PAGE,
            GENERAL_SETTINGS: GENERAL_SETTINGS,
            getAmountByLabel: getAmountByLabel,
            correlateActiveAndInactiveWidgets:
                correlateActiveAndInactiveWidgets,
            isValidPlatformSettings: isValidPlatformSettings,
            niceWidgetName: niceWidgetName,
            extractIdsOfNetworkPoints: extractIdsOfNetworkPoints
        };

        function getAmountByLabel(label) {
            for (var amount in GENERAL_SETTINGS.AMOUNT) {
                if (!GENERAL_SETTINGS.AMOUNT.hasOwnProperty(amount)) {
                    continue;
                }

                if (GENERAL_SETTINGS.AMOUNT[amount].label === label) {
                    return GENERAL_SETTINGS.AMOUNT[amount];
                }
            }
        }

        function correlateActiveAndInactiveWidgets(activeWidgets) {
            var correlatedWidgets = {
                activeWidgets: [],
                inactiveWidgets: []
            };

            correlatedWidgets.activeWidgets = activeWidgets;

            var i;
            for (i = 0; i < ALL_WIDGETS.length; i++) {
                if (
                    correlatedWidgets.activeWidgets.indexOf(ALL_WIDGETS[i]) ===
                    -1
                ) {
                    correlatedWidgets.inactiveWidgets.push(ALL_WIDGETS[i]);
                }
            }

            return correlatedWidgets;
        }

        /**
         * Extract the ids of network points.
         *
         * @param selectedNetworkPoints {Array} Objects of network points
         * @returns {Array} Ids of network points.
         */
        function extractIdsOfNetworkPoints(
            selectedNetworkPoints: { [index: string]: any }[]
        ) {
            var newNetworkPointIds = [];

            var i;
            for (i = 0; i < selectedNetworkPoints.length; i++) {
                newNetworkPointIds.push(selectedNetworkPoints[i].id);
            }
            return newNetworkPointIds;
        }

        function isValidPlatformSettings(platSett) {
            if (!platSett) {
                return false;
            }

            return !!(
                (platSett.cost === 'SUBUNIT' || platSett.cost === 'UNIT') &&
                (platSett.amount === 'KILO' || platSett.amount === 'MEGA') &&
                (platSett.favoriteNetworkPoints === 'SHIPPER' ||
                    platSett.favoriteNetworkPoints === 'USER') &&
                (platSett.recentActivities === 'SHIPPER' ||
                    platSett.recentActivities === 'USER')
            );
        }

        /**
         * "UPPERCASE_STRING" to "First uppercase".
         *
         * @param {string} name The name of the widget
         * @returns {string} The nicer form of the name
         */
        function niceWidgetName(name) {
            var niceName;
            switch (name) {
                case 'AUCTIONS': {
                    niceName = 'Live and upcoming auctions';
                    break;
                }
                case 'NETWORK_POINTS': {
                    niceName = 'Your favourite network points';
                    break;
                }
                case 'PROPOSALS': {
                    niceName =
                        'My own proposals / Trade proposals at your network points';
                    break;
                }
                case 'ACTIVITIES': {
                    niceName = "Your Company's activity in the last 24 hours";
                    break;
                }
                default: {
                    niceName = (
                        name.toLowerCase().charAt(0).toUpperCase() +
                        name.toLowerCase().slice(1)
                    )
                        .split('_')
                        .join(' ');
                    break;
                }
            }
            return niceName;
        }
    }
})();
